module.exports = __webpack_public_path__ + "img/logo.2aa1601c.png";